import fetchSuGRCities, { type City } from '@/helpers/fetchSuGRCities';
import { QueryObserverOptions, useQuery } from 'react-query';

const fetchCities = (zipCode: string | undefined) => async () => {
  if (!zipCode) {
    throw new Error('Missing zipCode');
  }

  return fetchSuGRCities(zipCode);
};

const useSuGRCities = (
  zipCode: string | undefined,
  queryConfig: QueryObserverOptions<City[]> = {}
) => {
  return useQuery<City[]>(['zipCodeAddress', zipCode], fetchCities(zipCode), {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    staleTime: Infinity,
    retry: 1,
    enabled: zipCode?.length === 5,
    ...queryConfig,
  });
};

export default useSuGRCities;
